import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              At Standard Chartered Bank Egypt, we achieve this balance through a proactive and
              integrated approach. We embed compliance considerations into the early stages of
              business strategy and product development. This 'compliance by design' philosophy
              ensures that regulatory requirements are addressed efficiently, minimizing the need
              for costly and disruptive retrofits. This allows SCB to maintain agility while
              effectively managing our compliance obligations.
              <br />
              <br />
              Fraud detection is deeply integrated into our compliance strategy through a
              combination of technology, processes, and people. Standard Chartered Bank utilizes
              sophisticated fraud analytics platforms to identify anomalous transactions and
              patterns. A culture of vigilance is key. Standard Chartered Bank continually refine
              our processes based on emerging fraud trends and feedback from investigations.
              <br />
              <br />
              My top priorities for enhancing the bank’s compliance framework includes Strengthening
              Data Analytics: Enhancing our data analytics capabilities to improve risk prediction
              and detection. Enhancing Regulatory Technology (RegTech): Investing in advanced
              RegTech solutions to automate compliance processes and improve efficiency.
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Compliance is often seen as a balancing act between meeting regulatory
                requirements and ensuring business agility. How do you balance compliance
                obligations while maintaining operational efficiency at Standard Chartered Bank
                Egypt?
              </strong>
            </h5>

            <h5 className="text-white">
              At Standard Chartered Bank Egypt, we achieve this balance through a proactive and
              integrated approach. We embed compliance considerations into the early stages of
              business strategy and product development. This 'compliance by design' philosophy
              ensures that regulatory requirements are addressed efficiently, minimizing the need
              for costly and disruptive retrofits. This allows us to maintain agility while
              effectively managing our compliance obligations.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With increasing regulatory scrutiny, effective compliance risk management is vital
                for protecting the bank. What key strategies do you use to proactively identify,
                assess, and mitigate compliance risks?
              </strong>
            </h5>
            <h5 className="text-white">
              Our approach to compliance risk management is centered on a robust, multi-layered
              framework. We employ advanced data analytics and monitoring tools to detect emerging
              risks and patterns.
              <br />
              <br />
              <b>
                <ul>
                  <li>
                    Enhanced Due Diligence: Implementing rigorous customer due diligence and
                    enhanced due diligence procedures, particularly for high-risk clients.{" "}
                  </li>
                  <li>
                    Transaction Monitoring: Utilizing sophisticated transaction monitoring systems
                    to identify suspicious activities.
                  </li>
                  <li>
                    Regulatory Change Management: Establishing a dedicated team to monitor and
                    interpret regulatory changes, ensuring timely implementation of necessary
                    updates.
                  </li>
                  <li>
                    Internal Audits and Reviews: Conducting regular internal audits and reviews to
                    assess the effectiveness of our compliance controls."
                  </li>
                </ul>
              </b>
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-Fraud detection is a critical part of compliance frameworks. How do you integrate
                fraud investigation processes into your overall compliance strategy to protect both
                the bank and its customers?
              </strong>
            </h5>
            <h5 className="text-white">
              Fraud detection is deeply integrated into our compliance strategy through a
              combination of technology, processes, and people. We utilize sophisticated fraud
              analytics platforms to identify anomalous transactions and patterns. We have
              established clear reporting channels for suspicious activities, encouraging both
              employees and customers to report potential fraud.We also collaborate closely with
              regulators and industry peers to share information and best practices. A culture of
              vigilance is key. We continually refine our processes based on emerging fraud trends
              and feedback from investigations.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Credit risk plays a fundamental role in the banking sector. How do you ensure
                credit risk mitigation is effectively embedded into the underwriting process without
                affecting business growth?
              </strong>
            </h5>
            <h5 className="text-white">
              We embed credit risk mitigation into the underwriting process by implementing a
              data-driven, risk-based approach.Critically, we strive to maintain a balance between
              risk management and business growth by:
              <ul>
                <li>
                  Segmenting Customers: Tailoring our credit policies to different customer segments
                  and risk profiles.
                </li>
                <li>
                  Utilizing Collateral and Guarantees: Securing loans with appropriate collateral
                  and guarantees.
                </li>
                <li>
                  Diversifying our Portfolio: Spreading our credit risk across a diverse range of
                  industries and sectors.
                </li>
                <li>
                  Regular Portfolio Reviews: Performing frequent reviews of our credit portfolio to
                  ensure that it remains within acceptable risk parameters.
                </li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Egypt's regulatory environment is constantly evolving. What are the biggest
                challenges you face in navigating Egypt’s regulatory landscape, and how do you
                ensure the bank remains compliant?
              </strong>
            </h5>
            <h5 className="text-white">
              Navigating Egypt's evolving regulatory landscape presents several key challenges,
              including:
              <br />
              <ul>
                <li>
                  Rapid Regulatory Changes: The pace of regulatory change requires constant
                  monitoring and adaptation.
                </li>
                <li>
                  Interpretation and Application: Ensuring consistent interpretation and application
                  of new regulations across the organization.
                </li>
                <li>
                  Technology Integration: Adapting our technology systems to meet new regulatory
                  requirements.
                </li>
                <li>
                  Talent and Expertise: Attracting and retaining talent with the necessary
                  regulatory expertise
                </li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your litigation background adds a unique dimension to your compliance leadership.
                How does your legal experience strengthen your approach to regulatory compliance,
                risk management, and dispute resolution?
              </strong>
            </h5>
            <h5 className="text-white">
              My litigation background provides a strong foundation for my role in compliance
              leadership. It enables me to:
              <ul>
                <li>
                  Anticipate Regulatory Risks: My experience in legal interpretation and analysis
                  allows me to anticipate potential regulatory risks and develop proactive
                  mitigation strategies.{" "}
                </li>
                <li>
                  Conduct Thorough Investigations: My investigative skills are invaluable in
                  conducting internal investigations and ensuring compliance with legal and
                  regulatory requirements.{" "}
                </li>
                <li>
                  Manage Disputes Effectively: My experience in dispute resolution enables me to
                  manage regulatory inquiries and legal disputes effectively, minimizing potential
                  liabilities.{" "}
                </li>
                <li>
                  Strengthen Contractual Frameworks: My legal expertise helps to strengthen our
                  contractual frameworks, ensuring they are compliant and protect the bank's
                  interests.{" "}
                </li>
                <li>
                  Enhance Regulatory Reporting: my understanding of legal documentation enhances the
                  quality of regulatory reporting. Essentially, my legal training provides a
                  structured and analytical approach to compliance, ensuring that we are not only
                  meeting regulatory requirements but also mitigating potential legal and
                  reputational risks.
                </li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Digital transformation is reshaping compliance functions globally. How is
                technology and automation helping Standard Chartered Bank Egypt enhance compliance
                monitoring, reporting, and risk management?
              </strong>
            </h5>
            <h5 className="text-white">
              Digital transformation is a key enabler of our compliance strategy. We are leveraging
              technology and automation to:
              <ul>
                <li>
                  Enhance Monitoring: Utilizing advanced analytics to monitor transactions and
                  identify suspicious activities in real-time.{" "}
                </li>
                <li>
                  Automate Reporting: Automating regulatory reporting processes, reducing manual
                  effort and minimizing errors.{" "}
                </li>
                <li>
                  Improve Risk Assessment: Leveraging data analytics to assess and predict
                  compliance risks more accurately.{" "}
                </li>
                <li>
                  Streamline KYC/AML Processes: Implementing digital KYC and AML solutions to
                  streamline customer onboarding and due diligence.{" "}
                </li>
                <li>
                  Enhance Training: Utilizing e-learning platforms to provide accessible and
                  engaging compliance training to our staff.
                </li>
                <li>
                  Data Governance: Improving data governance and quality to ensure accurate and
                  reliable compliance reporting.
                </li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Looking ahead, what are your top priorities for enhancing the bank’s compliance
                framework and embedding a culture of integrity and accountability across the
                organization?
              </strong>
            </h5>
            <h5 className="text-white">
              My top priorities for enhancing the bank’s compliance framework include:
              <ul>
                <li>
                  Strengthening Data Analytics: Enhancing our data analytics capabilities to improve
                  risk prediction and detection.{" "}
                </li>
                <li>
                  Enhancing Regulatory Technology (RegTech): Investing in advanced RegTech solutions
                  to automate compliance processes and improve efficiency.{" "}
                </li>
                <li>
                  Developing a Culture of Ethical Conduct: Reinforcing a strong culture of integrity
                  and accountability through continuous training and communication.{" "}
                </li>
                <li>
                  Enhancing Regulatory Engagement: Strengthening our engagement with regulatory
                  authorities to ensure proactive compliance.{" "}
                </li>
                <li>
                  Investing in Talent Development: Developing and retaining talent with the
                  necessary expertise to navigate the evolving regulatory landscape.{" "}
                </li>
                <li>
                  Improving Third-Party Risk Management: Enhancing our framework for managing risks
                  associated with third-party vendors and partners.{" "}
                </li>
                <li>
                  Focusing on financial crime compliance: Keeping up with the ever changing
                  landscape of financial crime, and ensuring that our systems and people are well
                  equiped to stop it.{" "}
                </li>
              </ul>
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
